import Notices          from "../../../domain/notice/Notices";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  GET_NOTICES = "GET_NOTICES",
}

export interface GetNoticesAction extends ResKaReduxAction {
  notices: Notices;
}

export const getNoticesAction = (notices: Notices): GetNoticesAction => ({
  type: ACTION_TYPE.GET_NOTICES,
  notices: notices
});
